import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { SwiperSlide } from 'swiper/react';

import OverflowCarousel from 'components/website/OverflowCarousel';
import useTradingPoints from 'hooks/useTradingPoints';

import FooterMap from './FooterMap';

import './bold-store.scss';

const BoldStore = ({ boldStoreCarousel, promo }) => {
  const tradingPoints = useTradingPoints();

  return (
    <section className="home-bold-store">
      <div className="section-container ">
        <div className="section-title">
          <h2 className="title-header-bold-white">Ven a conocer lo mejor de Bold en nuestra tienda</h2>
          <p className="text-subtitle">Compra nuestros productos y recibe asesoramiento de expertos en tiempo real.</p>
        </div>
        <div className="swiper-container">
          <OverflowCarousel hasPagination>
            <>
              {boldStoreCarousel.map((item, i) => (
                <SwiperSlide key={`carousel-overflow-${i + 1}`}>
                  <GatsbyImage image={getImage(item)} alt="Bold" />
                </SwiperSlide>
              ))}
            </>
          </OverflowCarousel>
        </div>
      </div>

      <FooterMap tradingPoints={tradingPoints[0]} cities={tradingPoints[1]} promoHome={promo} />
    </section>
  );
};

export default BoldStore;
